import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { selectScheduleDate } from "ContentActions";
import ScheduleDateItem from "./schedule_date_item";
import { isEmpty } from "BaseFunctions";
import { DEVELOPMENT_TYPE } from "Constants";

class ScheduleDatesList extends Component {
  renderList() {
    return this.props.dates.map((date) => (
      <ScheduleDateItem key={date.scheduledateid} date={date} />
    ));
  }

  componentDidMount() {
    // debugger;
    var selectedDate = this.props.dates[0];
    if (
      this.props.selectedScheduleDate &&
      !isEmpty(this.props.selectedScheduleDate)
    ) {
      selectedDate = this.props.selectedScheduleDate;
    }

    // var match = [];
    // if (DEVELOPMENT_TYPE === "koachify") {
    //   var today = moment().format("YYYY-MM-DD");

    //   match = _.filter(this.props.dates, (obj) => {
    //     return obj.scheduledate == today;
    //   });
    // }
    // if (match.length > 0 && isEmpty(this.props.selectedScheduleDate)) {
    //   this.props.selectScheduleDate(match[0]);
    // } else {
    //   if (selectedDate) this.props.selectScheduleDate(selectedDate);
    // }

    if (selectedDate) this.props.selectScheduleDate(selectedDate);
  }

  render() {
    if (this.props.isFetching) {
      return <div />;
    }
    return (
      <ul className="list-group schedule-dates-ul">{this.renderList()}</ul>
    );
  }
}

function mapStateToProps(state) {
  var dates = [];
  if (state.scheduleData.payload.scheduledates_by_eventid)
    var scheduledates =
      state.scheduleData.payload.scheduledates_by_eventid.filter(
        (date) => date.isactive
      );
  var sortArrAvailable = _.sortBy(scheduledates, "scheduledate", "asc");
  dates = sortArrAvailable;

  if (DEVELOPMENT_TYPE === "koachify") {
    dates = state.sessionWeekdays;
  }

  return {
    isFetching: state.scheduleData.isFetching,
    dates,
    selectedScheduleDate: state.selectedScheduleDate,
  };
}

export default connect(mapStateToProps, { selectScheduleDate })(
  ScheduleDatesList
);
